@if (loading) {
  <p>{{ 'COMMON.LOADING' | translate }}</p>
} @else if (!rows.length) {
  <div class="patient-purchases__empty">{{ 'PATIENT_SPACE.PURCHASES.EMPTY' | translate }}</div>
} @else {
  <section class="patient-purchases">
    <article class="patient-purchases__row" *ngFor="let row of rows">
      <div>
        <strong>{{ row?.product?.name || '-' }}</strong>
        <p>{{ row?.site?.name || '-' }}</p>
      </div>
      <div>
        <span>{{ row?.sales_date | date: 'dd/MM/yyyy HH:mm' }}</span>
        <span>{{ row?.price | number: '1.2-2' }}</span>
      </div>
    </article>
  </section>
}
